import { Avatar, Grid } from '@mui/material'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { HttpCacheWorkflow } from 'src/http/workflow/httpCacheWorkflow'
import { EntityWithIdAndDescriptionFields, EntityWithIdFields, SectorComercialFields, UnidadNegocioFields } from 'src/types'
import { SistemaPrincipalFields } from "src/types/workflow/cache"
import { AsyncSelect, ControlledDatePicker } from "../../../../../components/forms"
import { useLoadOptions } from "../../../../../hooks/useLoadOptions"
import CardActions from '../../../components/CardActions'
import { SectionBox } from '../../../components/FieldView'
import { OperacionAFOPUFields } from '../../afopu/types/fields'
import { useNOTESSectorComercialTipos, useNOTESUnidadNegocio } from "../hooks/useNOTESCache"
import { OperacionNOTESFields } from '../types/fields'
import { useEffect } from 'react'
import { UnidadNegocioTipo, SectorComercialTipo } from 'src/types/enum/enum'

interface SeccionNOTESDatosOperacionProps {
  formMethods: UseFormReturn<any>
  codSistema: number,
  codPais: number
}

export const SeccionNuevoNOTESDatosOperacion = ({ formMethods, codSistema, codPais }: SeccionNOTESDatosOperacionProps) => {
  const { control, setValue } = formMethods
  const unidadNegocioHook = useNOTESUnidadNegocio(codPais, codSistema)

  const loadUnidadNegocio = useLoadOptions({
    data: unidadNegocioHook.unidadNegocio,
    loading: unidadNegocioHook.isLoading,
    isError: unidadNegocioHook.isError,
    error: unidadNegocioHook.error
  });

  const watchedUnidadNegocio = useWatch({ control: control, name: OperacionAFOPUFields.CodUnidadNegocio });

  const sectorComercialTipos = useNOTESSectorComercialTipos(watchedUnidadNegocio, codSistema);
  const loadSectorComercial = useLoadOptions({
    data: sectorComercialTipos.sectorComercialTipos,
    loading: sectorComercialTipos.isLoading,
    isError: sectorComercialTipos.isError,
    error: sectorComercialTipos.error
  });

  const opcionesSistemaPrincipal = () => HttpCacheWorkflow.getSistemasPrincipales()
    .then(sis => (
      sis.map(opcion => (
        {
          id: opcion[EntityWithIdFields.Id],
          descripcion: opcion[EntityWithIdAndDescriptionFields.Description],
          icon: <Avatar src={opcion[SistemaPrincipalFields.SrcIcono]} sx={{ height: '20px', width: '20px' }} />
        }
      ))
    ))

  useEffect(() => {
    if (unidadNegocioHook.unidadNegocio?.length) {
      const match = unidadNegocioHook.unidadNegocio.find(
        (un) => un[UnidadNegocioFields.UnidadNegocioTipo] === UnidadNegocioTipo.SalesAndTrading
      );
      if (match) {
        setValue(OperacionNOTESFields.CodUnidadNegocio, match[SectorComercialFields.UnidadNegocioCodigo]);
      }
    }
  }, [unidadNegocioHook.unidadNegocio, setValue]);

  useEffect(() => {
    if (sectorComercialTipos.sectorComercialTipos?.length) {
      const match = sectorComercialTipos.sectorComercialTipos.find(
        (sc) => sc[SectorComercialFields.SectorComercialTipo] === SectorComercialTipo.NotasEstructuradas
      );
      if (match) {
        setValue(OperacionNOTESFields.CodSectorComercial, match[SectorComercialFields.SectorComercialCodigo]);
      }
    }
  }, [sectorComercialTipos.sectorComercialTipos, setValue]);

  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <SectionBox>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label={'Unidad de Negocio'}
            name={OperacionNOTESFields.CodUnidadNegocio}
            valueField={SectorComercialFields.UnidadNegocioCodigo}
            loadOptions={loadUnidadNegocio}
            control={control}
            selectNotNulleable
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label={'Equipo Comercial'}
            name={OperacionNOTESFields.CodSectorComercial}
            valueField={SectorComercialFields.SectorComercialCodigo}
            loadOptions={loadSectorComercial}
            control={control}
            selectNotNulleable
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <ControlledDatePicker name={OperacionNOTESFields.FechaSolicitud} control={control} label='Fecha Solicitud' />
        </Grid>
      </SectionBox>
    </CardActions>
  )
}
